import { apiPlugin, storyblokInit } from '@storyblok/react/rsc';
import { components } from 'pages/StoryBlok';
import { STORY_BLOK_ACCESS_TOKEN } from 'src/envVariables';

export const getStoryblokApi = storyblokInit({
  accessToken: STORY_BLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  apiOptions: { region: '' },
  components,
});
